import { FormCaptureFields } from '@/components/vsleads/types';

export function getDefaultFormCaptureConfig(): FormCaptureFields {
  return {
    videoId: '',
    tipo: 'form',
    is_active: true,
    
    layout: {
      orientation: 'vertical',
      position: 'center',
      side: 'right',
      width: 420,
      padding: 24,
      offset: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      },
    },
    
    fields: [
      {
        id: 'firstName',
        required: true,
        placeholder: 'Seu nome',
        order: 0,
      },
      {
        id: 'email',
        required: true,
        placeholder: 'Seu e-mail',
        order: 1,
      },
    ],
    
    content: {
      headline: {
        text: "Preencha para acessar o vídeo",
        placement: 'inside',
      },
      footer: 'Seus dados estão seguros conosco.',
      buttonText: 'Acessar vídeo',
      skip: {
        enabled: false,
        text: 'Ignorar',
      },
    },
    
    style: {
      container: {
        background: {
          type: 'solid',
          value: '#FFFFFF',
          opacity: 0.95,
        },
        radius: 12,
        shadow: 2,
        border: {
          width: 0,
          color: '#E5E7EB',
        },
        blur: 0,
      },
      inputs: {
        shape: 'rounded',
        background: '#F9FAFB',
        border: '#E5E7EB',
      },
      text: {
        title: '#111827',
        body: '#6B7280',
      },
      button: {
        background: '#2563EB',
        text: '#FFFFFF',
        hoverBackground: '#1D4ED8',
        pressedBackground: '#1E40AF',
      },
      overlayOnShow: 0.3,
    },
    
    timer: {
      enabled: false,
      showAt: '00:00',
      pauseOnOpen: true,
      pauseOnSubmit: false,
      blockCloseUntilSubmit: false,
    },
    
    behavior: {
      showTitle: true,
      autoCloseOnSubmit: true,
      reopenIfNotSubmitted: false,
    },
  };
}

export function getFieldLabel(fieldId: string): string {
  const labels: Record<string, string> = {
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    whatsapp: 'WhatsApp',
  };
  return labels[fieldId] || fieldId;
}

export function getFieldPlaceholder(fieldId: string): string {
  const placeholders: Record<string, string> = {
    firstName: 'Seu nome',
    lastName: 'Seu sobrenome',
    email: 'seu@email.com',
    whatsapp: '+55 (11) 99999-9999',
  };
  return placeholders[fieldId] || '';
}
